import React, { createContext } from 'react';
import PageProps from './props';

const PageContext = React.createContext<PageProps>(null);

export default PageContext;
